import {UmpireLinkTypeEnum} from '../umpire-link-type';

export interface UmpireCustomLink {
  id: string;
  type: 'component';
  attributes: {
    id: number;
    index: number;
    kind: UmpireLinkTypeEnum.CUSTOM_LINK;
    name: string;
    url: string;
  };
}
